var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.8333C12.0125 12.8333 12.8334 12.0125 12.8334 11C12.8334 9.98744 12.0125 9.16663 11 9.16663C9.9875 9.16663 9.16669 9.98744 9.16669 11C9.16669 12.0125 9.9875 12.8333 11 12.8333Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.41667C12.0125 6.41667 12.8334 5.59586 12.8334 4.58333C12.8334 3.57081 12.0125 2.75 11 2.75C9.9875 2.75 9.16669 3.57081 9.16669 4.58333C9.16669 5.59586 9.9875 6.41667 11 6.41667Z",
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25C12.0125 19.25 12.8334 18.4292 12.8334 17.4167C12.8334 16.4042 12.0125 15.5834 11 15.5834C9.9875 15.5834 9.16669 16.4042 9.16669 17.4167C9.16669 18.4292 9.9875 19.25 11 19.25Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.f0d396e4.svg";
export { ForwardRef as ReactComponent };